import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import MenuCategories from '../components/menu_categories';
import MenuItems from '../components/menu_items';
import OrderTotal from '../components/order_total';
import OrderItems from '../components/order_items';
//import Footer from '../components/footer';
import Sidebar from './sidebar';
import Overlay from '../components/overlay';
import Header from './header';
import ModalOrderPayment from './modal_order_payment';
import ModalOrderName from './modal_order_name';
import ModalOrderNote from './modal_order_note';
import ModalOrderDiscount from './modal_order_discount';
import ModalOrderClose from './modal_order_close';
import ModalOrderLocation from './modal_order_location';
import ModalItemModifier from './modal_item_modifier';
import ModalItemNote from './modal_item_note';
import PosLeftNav from './pos_left_nav';
import PosOrderNav from './pos_order_nav';

class Pos extends Component {

  render() {
    //console.log(window.store.getState());
    if ( (_.isEmpty(this.props.restaurant.menuItems)) ) {
      return(
        <div>
          <Overlay />
          <Sidebar />
          <Header />
          <div className="site-content">
            <nav className="navbar navbar-light bg-white navbar-bottom-line b-a mb-1 p-1">
              <button className="navbar-toggler hidden-md-up" type="button" data-toggle="collapse" data-target="#exCollapsingNavbar2" aria-controls="exCollapsingNavbar2" aria-expanded="false" aria-label="Toggle navigation"></button>
              <PosOrderNav />
              <PosLeftNav />
            </nav>
            <div className="box box-block">
              <div>There are no menu items to show.</div>
            </div>
          </div>
        </div>
      );
    }

    return(
      <div>
        <Overlay />
        <Sidebar />
        <Header />
        <div className="site-content">
          <nav className="navbar navbar-light bg-white navbar-bottom-line b-a p-1">
            <div className="container pl-0 pr-0">
              <div className="row">
                <PosLeftNav />
                <PosOrderNav />
              </div>
            </div>
          </nav>
          <nav className="navbar navbar-light bg-white navbar-bottom-line pt-1">
            <button className="navbar-toggler hidden-md-up" type="button" data-toggle="collapse" data-target="#NavbarCategories" aria-controls="NavbarCategories" aria-expanded="false" aria-label="Toggle navigation"></button>
            <div className="navbar-right navbar-toggleable-sm collapse" id="NavbarCategories">
              <MenuCategories />
            </div>
          </nav>
          <div className="content-area py-1">
            <div className="container-fluid">
              <div className="">
                <div className="row no-gutter">
                  <div className="col-md-4 bg-white">
                    <OrderTotal />
                    <OrderItems />
                  </div>
                  <div className="col-md-8 bg-gray">
                    <MenuItems />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ModalOrderName />
        <ModalOrderPayment />
        <ModalOrderNote />
        <ModalOrderDiscount />
        <ModalOrderClose />
        <ModalOrderLocation />
        <ModalItemModifier />
        <ModalItemNote />
      </div>
    );
  }
}

function mapStateToProps({ restaurant }) {
  return { restaurant };
}

export default connect(mapStateToProps, null)(Pos);



// WEBPACK FOOTER //
// ./src/containers/pos.js